// libraries.
import { useDispatch } from 'react-redux';
import { robotoRegular } from '@habitech/shared';
import { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';

// selectors.
import { setNidSelected } from '@domains/documents-review/store/slices/document-review-slice';

export const SearchDocuments = () => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    dispatch(setNidSelected(''));
  }, [dispatch]);

  const handleSearch = () => {
    dispatch(setNidSelected(inputValue.trim()));
    setInputValue('');
  };

  return (
    <div className="d-flex flex-column gap-4">
      <InputGroup style={{ fontFamily: robotoRegular, fontSize: '14px' }}>
        <Form.Control
          placeholder="Buscar NID"
          aria-label="Recipient's username"
          aria-describedby="basic-addon2"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
        />
        <Button
          variant="outline-secondary"
          id="button-addon2"
          onClick={handleSearch}
        >
          Buscar
        </Button>
      </InputGroup>
    </div>
  );
};
